import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const CheckCircleLight = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 12 12" {...rest}>
      <path
        d="M6 10.8C3.34903 10.8 1.2 8.65097 1.2 6C1.2 3.34903 3.34903 1.2 6 1.2C8.65097 1.2 10.8 3.34903 10.8 6C10.8 8.65097 8.65097 10.8 6 10.8ZM0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6ZM9.21008 4.70983C9.4444 4.47551 9.4444 4.09561 9.21008 3.8613C8.97577 3.62698 8.59587 3.62698 8.36155 3.8613L4.92867 7.29418L3.85294 6.21844C3.61862 5.98413 3.23872 5.98413 3.00441 6.21844C2.7701 6.45275 2.7701 6.83265 3.00441 7.06697L4.50441 8.56697C4.73872 8.80128 5.11862 8.80128 5.35294 8.56697L9.21008 4.70983Z"
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </StyledIcon>
  );
};

CheckCircleLight.propTypes = {
  color: PropTypes.string
};

CheckCircleLight.defaultProps = {
  color: 'var(--color-text-primary)'
};

export default CheckCircleLight;
